import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormFeedback,
  Input,
} from "reactstrap"
import { Link, useLocation } from "react-router-dom"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import Snackbars from "../../Utils/Snackbars"
import useRequests from "../../Utils/useRequests"
import { checkImageValidation } from "../../Utils/Common"

const Team = props => {
  //meta title
  document.title = "Property Team"
  const location = useLocation()
  const { getRequest, postRequest, postRequestByFormData } = useRequests()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: "",
      designation: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      designation: Yup.string().required("Please enter designation"),
    }),
    onSubmit: async values => {
      try {
        if (fileName === "") {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: "Please select a image with a valid image size!",
          }))
          resetAlertData()

          return false
        } else {
          if (fileName === "") {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: "error",
              message: "Please select a profile picture!",
            }))
            resetAlertData()

            return false
          } else {
            let submit1 = document.getElementById("submit1")
            submit1.disabled = true
            submit1.textContent = "Processing..."

            const formData = new FormData()
            formData.append("p_id", atob(props.match.params.id))
            formData.append("name", values.name)
            formData.append("designation", values.designation)
            formData.append("file", file)
            formData.append("fileName", fileName)
            const res = await postRequestByFormData(
              "add-property-team",
              formData,
            )

            if (res && res.code === 200) {
              handleLoadGetPropertyTeam(PreferredLanguage)

              setAlertData(AlertData => ({
                ...AlertData,
                variant: "success",
                message: res.message,
              }))
            } else {
              setAlertData(AlertData => ({
                ...AlertData,
                variant: "error",
                message: res.message,
              }))
            }
            resetAlertData()

            submit1.disabled = false
            submit1.textContent = "Add"

            validation1.setValues({
              name: "",
              designation: "",
            })
            setFile()
            setFileName("")

            setStandardModal1(false)
          }
        }
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      pt_id: "",
      name: "",
      designation: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      designation: Yup.string().required("Please enter designation"),
    }),
    onSubmit: async values => {
      try {
        let submit2 = document.getElementById("submit2")
        submit2.disabled = true
        submit2.textContent = "Processing..."
        const formData = new FormData()
        formData.append("pt_id", values.pt_id)
        formData.append("p_id", atob(props.match.params.id))
        formData.append("name", values.name)
        formData.append("designation", values.designation)
        formData.append("lang", PreferredLanguage)

        const res = await postRequestByFormData(
          "update-property-team-details",
          formData,
        )

        if (res && res.code === 200) {
          handleLoadGetPropertyTeam(PreferredLanguage)

          setAlertData(AlertData => ({
            ...AlertData,
            variant: "success",
            message: res.message,
          }))
        } else {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }))
        }
        resetAlertData()

        submit2.disabled = false
        submit2.textContent = "Add"

        setStandardModal2(false)
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const handleUploadProfilePic = async e => {
    if (fileName === "") {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: "Please select new profile picture!",
      }))
      resetAlertData()

      return false
    } else {
      let submit3 = document.getElementById("submit3")
      submit3.disabled = true
      submit3.textContent = "Processing..."

      const formData = new FormData()
      formData.append("pt_id", validation2.values.pt_id)
      formData.append("p_id", atob(props.match.params.id))
      formData.append("file", file)
      formData.append("fileName", fileName)
      const res = await postRequestByFormData(
        "update-property-team-profile-pic",
        formData,
      )
      if (res && res.code === 200) {
        handleLoadGetPropertyTeam(PreferredLanguage)

        setAlertData(AlertData => ({
          ...AlertData,
          variant: "success",
          message: res.message,
        }))
      } else {
        setAlertData(AlertData => ({
          ...AlertData,
          variant: "error",
          message: res.message,
        }))
      }
      resetAlertData()

      submit3.disabled = false
      submit3.textContent = "Upload"
    }
  }

  const handleDeleteTeamMember = async (pt_id, profile_pic) => {
    const jsonpar = JSON.stringify({
      pt_id: atob(pt_id),
      p_id: atob(props.match.params.id),
      profile_pic: profile_pic,
    })
    const res = await postRequest("delete-property-team", jsonpar)
    if (res && res.code === 200) {
      handleLoadGetPropertyTeam(PreferredLanguage)

      setAlertData(AlertData => ({
        ...AlertData,
        variant: "success",
        message: res.message,
      }))
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

  const [StandardModal1, setStandardModal1] = React.useState(false)
  const togStandardModal1 = async () => {
    setStandardModal1(true)
  }
  const [StandardModalDelete, setStandardModalDelete] = React.useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = React.useState(null);
  const togStandardModalDelete = (documentData) => {
    setDeleteDocumentData(documentData);
    setStandardModalDelete(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteDocumentData) {
      const res = await handleDeleteTeamMember(
        btoa(deleteDocumentData.pt_id),
        deleteDocumentData.profile_pic
      );
      setStandardModalDelete(false); 
    }
  }
  const [PropertiesTBody, setPropertiesTBody] = React.useState("")
  const handleT1Body = async (tempData, lang) => {
    let tempTBody = tempData.team.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>
          <img
            src={`${process.env.REACT_APP_API_URL}${tempData.url}${element.profile_pic}`}
            className="profile-pic"
          />
        </td>
        <td>{lang == "en" ? element.name : element.name_sp}</td>
        <td>{lang == "en" ? element.designation : element.designation_sp}</td>
        <td className="text-center">
          <div className="centerLink">
            <Link
              title="Edit Team Member"
              to="#"
              className="font-size-14 bg-primary edit-box"
              onClick={e => togStandardModal2(element, lang)}
            >
              <i className="bx bxs-edit"></i>
            </Link>
            <Link
              title="Delete Team Member"
              to={"#" + btoa(element.pt_id)}
              className="font-size-14 bg-primary edit-box"
              onClick={() => togStandardModalDelete(element)}
            >
              <i className="fas fa-trash"></i>
            </Link>
          </div>
        </td>
      </tr>
    ))

    setPropertiesTBody(tempTBody)
  }
  const handleLoadGetPropertyTeam = async lang => {
    const jsonpar = JSON.stringify({
      p_id: atob(props.match.params.id),
    })
    const res = await postRequest("get-property-team", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data
      handleT1Body(originalText, lang)
    } else {
      let tempTBody = (
        <tr>
          <td colSpan="5" className="text-center">
            No records found
          </td>
        </tr>
      )

      setPropertiesTBody(tempTBody)

      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

  const [StandardModal2, setStandardModal2] = React.useState(false)

  const togStandardModal2 = async (elementData, lang) => {
    let name = elementData.name
    let designation = elementData.designation
    if (lang !== "en") {
      name = elementData.name_sp
      designation = elementData.designation_sp
    }
    validation2.setValues({
      ...validation2.values,
      pt_id: elementData.pt_id,
      name: name,
      designation: designation,
    })
    setStandardModal2(true)
  }

  const [file, setFile] = useState()
  const [fileName, setFileName] = useState("")
  const saveFile = e => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0])
      setFileName(e.target.files[0].name)

      var imageValidationRes = checkImageValidation(e.target.files[0])
      if (imageValidationRes.status) {
        var url = URL.createObjectURL(e.target.files[0])
        var img = new Image()
        var width = 225
        var height = 225
        img.onload = function () {
          if (
            img.width < 220 ||
            (img.width > 230 && img.height < 220) ||
            img.height > 230
          ) {
            setFile()
            setFileName("")

            setAlertData(AlertData => ({
              ...AlertData,
              variant: "error",
              message: "Image perfect size is " + width + " * " + height,
            }))
            resetAlertData()
          }
          URL.revokeObjectURL(img.src)
        }
        img.src = url
      } else {
        setFile()
        setFileName("")

        setAlertData(AlertData => ({
          ...AlertData,
          variant: "error",
          message: imageValidationRes.msg,
        }))
        resetAlertData()

        return false
      }
    }
  }

  const [PreferredLanguage, setPreferredLanguage] = React.useState("en")
  const onChangePreferredLanguage = e => {
    setPreferredLanguage(e.target.value)
    handleLoadGetPropertyTeam(e.target.value)
  }

  React.useEffect(() => {
    handleLoadGetPropertyTeam("en")

    if (
      typeof location.state !== "undefined" &&
      typeof location.state.message !== "undefined"
    ) {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }))
      resetAlertData()
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Eshepay")}
            breadcrumbItem={props.t("Team")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Col xs="12" className="mb-2 cstm-fullWidth">
                    <Link className="back-link-2" to="/property"><i className="bx bx-left-arrow-alt"></i> Back</Link>
                    <div className="add-form">
                      <button
                        type="button"
                        onClick={e => togStandardModal1()}
                        className="btn btn-primary"
                      >
                        Add Team Member
                      </button>
                    </div>
                    <div className="lang-select">
                      <select
                        className="form-select top-right-lang"
                        name="preferred_language"
                        value={PreferredLanguage}
                        onChange={e => onChangePreferredLanguage(e)}
                      >
                        <option value={"en"}>English</option>
                        <option value={"sp"}>Spanish</option>
                      </select>
                      <i className="fas fa-angle-down"></i>
                    </div>
                  </Col>
                  <div className="table-rep-plugin cstm-fullWidth">
                    <div className="table-responsive">
                      <table
                        className="table table-hover table-highlight"
                        style={{ minWidth: "800px" }}
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Profile Picture</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>{PropertiesTBody}</tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={StandardModal1}
        backdrop={"static"}
        centered
        className="transation"
      >
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Add Team Member</h5>
            <button
              type="button"
              onClick={e => setStandardModal1(false)}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">Select Profile Picture : </label>
              <div className="input-group">
                <input
                  type="file"
                  className="form-control fileUpload"
                  aria-describedby="submit3"
                  aria-label="Upload"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={saveFile}
                />
              </div>
              <label style={{ color: "red", marginTop: "0.5rem" }}>
                Image perfect size is 225 * 225
              </label>
            </div>
            <div className="mb-3">
              <label className="form-label">Name :</label>
              <Input
                name="name"
                type="text"
                placeholder={"Name"}
                onChange={e =>
                  validation1.setValues({
                    ...validation1.values,
                    name: e.target.value,
                  })
                }
                onBlur={validation1.handleBlur}
                value={validation1.values.name || ""}
                invalid={
                  validation1.touched.name && validation1.errors.name
                    ? true
                    : false
                }
              />
              {validation1.touched.name && validation1.errors.name ? (
                <FormFeedback type="invalid">
                  {validation1.errors.name}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label">Designation :</label>

              <Input
                name="designation"
                type="text"
                placeholder={"Designation"}
                onChange={e =>
                  validation1.setValues({
                    ...validation1.values,
                    designation: e.target.value,
                  })
                }
                onBlur={validation1.handleBlur}
                value={validation1.values.designation || ""}
                invalid={
                  validation1.touched.designation &&
                  validation1.errors.designation
                    ? true
                    : false
                }
              />
              {validation1.touched.designation &&
              validation1.errors.designation ? (
                <FormFeedback type="invalid">
                  {validation1.errors.designation}
                </FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              id="submit1"
              onClick={e => {
                e.preventDefault()
                validation1.handleSubmit()
                return false
              }}
              type="button"
              color="primary"
            >
              Add
            </Button>
            <Button
              type="button"
              color="light"
              onClick={e => setStandardModal1(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal
        isOpen={StandardModal2}
        backdrop={"static"}
        centered
        className="transation"
      >
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Update Team Member</h5>
            <button
              type="button"
              onClick={() => setStandardModal2(false)}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label mt-3">
                Select New Profile Picture:
              </label>
              <div className="input-group">
                <input
                  type="file"
                  className="form-control fileUpload"
                  aria-describedby="submit3"
                  aria-label="Upload"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={saveFile}
                />
                <button
                  className="btn btn-primary fileUpload"
                  type="button"
                  id="submit3"
                  onClick={e => handleUploadProfilePic()}
                >
                  Upload
                </button>
              </div>
              <label style={{ color: "red", marginTop: "0.5rem" }}>
                Image perfect size is 225 * 225
              </label>
            </div>

            <div className="mb-3">
              <label className="form-label">Name:</label>
              <Input
                name="name"
                type="text"
                placeholder={"Name"}
                onChange={e =>
                  validation2.setValues({
                    ...validation2.values,
                    name: e.target.value,
                  })
                }
                onBlur={validation2.handleBlur}
                value={validation2.values.name || ""}
                invalid={
                  validation2.touched.name && validation2.errors.name
                    ? true
                    : false
                }
              />
              {validation2.touched.name && validation2.errors.name ? (
                <FormFeedback type="invalid">
                  {validation2.errors.name}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label">Designation:</label>
              <Input
                name="designation"
                type="text"
                placeholder={"Designation"}
                onChange={e =>
                  validation2.setValues({
                    ...validation2.values,
                    designation: e.target.value,
                  })
                }
                onBlur={validation2.handleBlur}
                value={validation2.values.designation || ""}
                invalid={
                  validation2.touched.designation &&
                  validation2.errors.designation
                    ? true
                    : false
                }
              />
              {validation2.touched.designation &&
              validation2.errors.designation ? (
                <FormFeedback type="invalid">
                  {validation2.errors.designation}
                </FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              id="submit2"
              onClick={e => {
                e.preventDefault()
                validation2.handleSubmit()
                return false
              }}
              type="button"
              color="primary"
            >
              Update
            </Button>
            <Button
              type="button"
              color="light"
              onClick={() => setStandardModal2(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>
      <Modal
          isOpen={StandardModalDelete}
          backdrop={"static"}
          centered
          className="transation"
        >
          <div>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Confirm Delete</h5>
              <button
                type="button"
                onClick={() => setStandardModalDelete(false)}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <ModalBody>
              <p>Are you sure you want to delete this team member?</p>
              <p><strong>{deleteDocumentData ? deleteDocumentData.document_name : ''}</strong></p>
            </ModalBody>
            <ModalFooter>
              <Button
                color="danger"
                onClick={handleConfirmDelete}
              >
                Delete
              </Button>
              <Button
                type="button"
                color="light"
                onClick={() => setStandardModalDelete(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Team)
